import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Analytics from './components/Analytics'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Portfolio from './pages/Portfolio'
import ProjectDetail from './pages/ProjectDetail'
import Contact from './pages/Contact'
import Demo from './pages/Demo'
import WebDevelopment from './pages/services/WebDevelopment'
import AIMLEngineer from './pages/services/AIMLEngineer'
import MobileApps from './pages/services/MobileApps'
import AIChatbotsAgents from './pages/services/AIChatbotsAgents'
import AIAutomation from './pages/services/AIAutomation'
import IOSAndroidApps from './pages/services/IOSAndroidApps'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'

function App() {
  return (
    <Router>
      <Analytics />
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/ai-ml-engineer" element={<AIMLEngineer />} />
          <Route path="/services/mobile-apps" element={<MobileApps />} />
          <Route path="/services/ai-chatbots-agents" element={<AIChatbotsAgents />} />
          <Route path="/services/ai-automation" element={<AIAutomation />} />
          <Route path="/services/ios-android-apps" element={<IOSAndroidApps />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/project/:category/:id" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demo" element={<Demo />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
